document.addEventListener('DOMContentLoaded', function () {
    const stickyWrapper = document.getElementById('stickyWrapper');
    const stickyAddToCartButton = document.querySelector('.sticky-add-to-cart');
    const addToCartWrapper = document.querySelector('.product-form__buttons');
    const addToCartButton = document.querySelector('.product-form__submit');
    const footer = document.querySelector('.footer__content-bottom');
    var chatButton;

    function toggleStickyWrapper() {
        const addToCartRect = addToCartWrapper.getBoundingClientRect();
        const footerRect = footer.getBoundingClientRect();
        const isButtonVisible = addToCartRect.top > 0 && addToCartRect.bottom < window.innerHeight;
        const isFooterVisible = footerRect.top > 0 && footerRect.bottom < window.innerHeight;

        if (!isButtonVisible && !isFooterVisible) {
            stickyWrapper.classList.remove('hide');
            if(chatButton){
                chatButton.classList.add('hide');
            }
        } else {
            stickyWrapper.classList.add('hide'); 
            if(chatButton){
                chatButton.classList.remove('hide');
            }
        }
    }

    stickyAddToCartButton.addEventListener('click', function () {
        if (addToCartButton) {
            addToCartButton.click();
        }
    });

    waitForElement('#ShopifyChat', (el) => {
        chatButton = el;
        chatButton.classList.add('hide');
    });
    

    window.addEventListener('scroll', toggleStickyWrapper);
    window.addEventListener('resize', toggleStickyWrapper);
});

function waitForElement(selector, callback) {
    const observer = new MutationObserver((mutations, obs) => {
        const element = document.querySelector(selector);
        if (element) {
            callback(element);
            obs.disconnect();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}

